var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_245",
    "data-name": "Group 245",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M0,0H22V22H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M5.667,17.583H2.917A.917.917,0,0,1,2,16.667V7.5a.917.917,0,0,1,.917-.917h2.75V2.917A.917.917,0,0,1,6.583,2H15.75a.917.917,0,0,1,.917.917V6.583h2.75a.917.917,0,0,1,.917.917v9.167a.917.917,0,0,1-.917.917h-2.75v1.833a.917.917,0,0,1-.917.917H6.583a.917.917,0,0,1-.917-.917Zm0-1.833v-.917a.917.917,0,0,1,.917-.917H15.75a.917.917,0,0,1,.917.917v.917H18.5V8.417H3.833V15.75ZM7.5,3.833v2.75h7.333V3.833Zm0,11.917V18.5h7.333V15.75ZM4.75,9.333H7.5v1.833H4.75Z",
    transform: "translate(-0.167 -0.167)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/printIcon.b0956c433cac950d1caedf74ab609813.svg";
export { ForwardRef as ReactComponent };